module.exports = __webpack_public_path__ + "img/68.84143b1e.jpg";